import { useEffect, useRef, useState } from "react";
import { Stack, Box, Text, Tabs, TabList, Tab, TabPanels, TabPanel, Flex, Input, FormLabel, Select, Button, Textarea, FormErrorMessage, FormControl, HStack, Heading, VStack, Grid, GridItem } from "@chakra-ui/react";
import 'services/Recruit/assets/css/CreateJobOpening/style.css';
import { ArrowBackIcon } from '@chakra-ui/icons';
import { globalStyles } from "common/theme/styles";
import { Field, Formik, Form } from "formik";
import { useNavigate, useParams } from "react-router-dom";
import ActionNavbar from "common/components/actionBar/ActionNavbar";
import { useDispatch, useSelector } from "react-redux";
import { getDepartments } from "common/redux/reducers/departmentSlice";
import { fetchUserData } from "common/redux/reducers/userSlice";
import { uploadAttachment } from "common/redux/reducers/attachmentSlice";
import { recruitConstant } from "services/Recruit/constant";
import { referralSchema } from "services/Crm/schema/referralSchema";
import { panelTabs } from "services/Recruit/data/panel.Data";
import SkillsSection from "services/Recruit/components/SkillsSection;";
import CustomDropdown from "services/Recruit/components/CustomDropdown/CustomDropdown";
import { timeSlots } from "services/Recruit/data/panel.Data";
import { totalExperienceOptions } from "services/Recruit/data/panel.Data";

const PanelCreate = ({ availability, experience, onAvailabilityChange, onExperienceChange }) => {
  const colors = globalStyles.colors;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const { users } = useSelector((state) => state.users);

  const handleTabChange = (index) => {
    setActiveTabIndex(index);
  };
  const handleFileChange = (dispatch, setFieldValue, fieldName) => (e) => {
    const file = e.target.files[0];
    if (file) {
      dispatch(uploadAttachment({ file, setFieldValue: (field, value) => setFieldValue(fieldName, value) }));
    }
  };

  useEffect(() => {
    dispatch(getDepartments());
    dispatch(fetchUserData());
  }, [dispatch]);

  return (
    <Box className="referral-mt" mt={5}>
      <ActionNavbar
        isCreatePage={true}
      />
      <Stack>
        <Box className="createJobOpening-container">
          <Box className='createJobOpening-mainContainer'>
            <Box className='createJobOpening-breadCrumb'>
              <ArrowBackIcon onClick={() => navigate("/recruit/panel")} fontSize="20px" />
              <Text className='createJobOpening-pageTitle'>{recruitConstant.createPanel}</Text>
            </Box>
          </Box>

          <Formik
            initialValues={{
              panelFullName: "",
              skills: [],
              totalExperience: "",
              availability: "",
            }}
            validationSchema={referralSchema}
          >
            {({ errors, touched, setFieldValue }) => (
              <Form>
                <Tabs index={activeTabIndex} onChange={handleTabChange} className="createJobOpening-tabsContainer" variant="unstyled" orientation="vertical">
                  {/* tab list  */}
                  <TabList w={'40%'} className="createJobOpening-tabListContainer">
                    {panelTabs.map(({ label, Icon }, index) => (
                      <Tab
                        className="createJobOpening-tabs"
                        key={index}
                        _selected={{
                          color: colors.cta['100'],
                          borderLeft: "2px solid",
                          borderColor: colors.cta['100'],
                        }}
                        _hover={{
                          color: colors.cta['100'],
                        }}
                        _focus={{ boxShadow: "none" }}
                        display="flex"
                        alignItems="center"
                        gap="8px"
                      >
                        <Icon size={20} />
                        {label}
                      </Tab>
                    ))}
                  </TabList>

                  {/* tab panels */}
                  <TabPanels w={'60%'} className="createJobOpening-tabsPanelContainer">
                    {/* job opening tab */}
                    <TabPanel className="createJobOpening-tabsPanel">
                      <section className="createJobOpening-tabsPanelBody">
                        <VStack spacing={4} align="stretch">
                          <Grid templateColumns="repeat(4, 1fr)" gap={6}>
                           <GridItem colSpan={2}>
                           <FormControl isInvalid={errors.panelFullName && touched.panelFullName}>
                              <FormLabel>{recruitConstant.panelName}</FormLabel>
                              <Field
                                as={Input}
                                name={recruitConstant.panelFullName}
                                placeholder={recruitConstant.enterPanelName}
                              />
                              <FormErrorMessage>{errors.panelFullName}</FormErrorMessage>
                            </FormControl>
                           </GridItem>
                           <GridItem colSpan={2} className="createSkillsBox">
                           <FormControl isInvalid={errors.skills && touched.skills}>
                           <FormLabel>{recruitConstant.skills}</FormLabel>
                              <SkillsSection initialSkills={[]} />
                              <FormErrorMessage>{errors.skills}</FormErrorMessage>
                            </FormControl>
                           </GridItem>
                           <GridItem colSpan={1}>
                           <FormControl isInvalid={errors.totalExprience && touched.totalExprience}>
                              <FormLabel>{recruitConstant.totalExprience}</FormLabel>
                              <CustomDropdown options={totalExperienceOptions} value={experience} onChange={onExperienceChange} />
                              <FormErrorMessage>{errors.skills}</FormErrorMessage>
                            </FormControl>
                           </GridItem>
                           <GridItem colSpan={1}>
                           <FormControl isInvalid={errors.availability && touched.availability}>
                              <FormLabel>{recruitConstant.availability}</FormLabel>
                              <CustomDropdown options={timeSlots} value={availability} onChange={onAvailabilityChange} />
                              <FormErrorMessage>{errors.skills}</FormErrorMessage>
                            </FormControl>
                           </GridItem>
                          </Grid>
                         
                          <Flex justifyContent="flex-end" mt={4} gap={3}>
                            <Button
                               variant="primary"
                              className="backBtn"
                              onClick={() => navigate("/recruit/panel")}
                            >
                              {recruitConstant.back}
                            </Button>
                            <Button type="submit" colorScheme="purple" onClick={() => navigate("/recruit/panel")}>
                              {id ? recruitConstant.update : recruitConstant.save}
                            </Button>
                          </Flex>
                        </VStack>
                      </section>
                    </TabPanel>
                  </TabPanels>
                </Tabs>
              </Form>
            )}
          </Formik>
        </Box>
      </Stack>
    </Box>
  );
};

export default PanelCreate;
